module.exports = __webpack_public_path__ + "img/p-banner-2100.4a0f3d73.png";